(function () {
  var TABLET_MAX = 1024;
  var mql = window.matchMedia('(max-width: ' + TABLET_MAX + 'px)');
  var applying = false;
  var syncing = false;
  var cleaning = false;
  var DEBUG =
    window.location.search.indexOf('ha-nav-debug') !== -1 ||
    window.localStorage.getItem('ha-frcp-nav-debug') === '1';

  function log() {
    if (!DEBUG) return;
    var args = ['[ha-frcp-nav]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  function getNav() {
    return document.querySelector('.frcp-app .frcp-nav.frcp-nav--dropdown-menu');
  }

  function getNavToggle(nav) {
    nav = nav || getNav();
    if (!nav) return null;

    return nav.querySelector(':scope > .frcp-nav-button, :scope > button.frcp-nav-button');
  }

  function getNavSnapshot() {
    var nav = getNav();
    var main = document.querySelector('.frcp-app .frcp-main');
    var toggle = getNavToggle(nav);
    var menu = nav && nav.querySelector('.frcp-nav__menu');

    return {
      viewport: mql.matches ? 'tablet/mobile' : 'desktop',
      bodyModalClass: document.body.classList.contains('ha-frcp-nav-modal'),
      navClasses: nav ? nav.className : null,
      navOpen: nav ? nav.classList.contains('frcp-nav--open') : false,
      mainMenuFixed: main ? main.classList.contains('frcp-main--menu-fixed') : false,
      toggleFound: !!toggle,
      toggleText: toggle ? toggle.textContent.trim() : null,
      toggleAriaExpanded: toggle ? toggle.getAttribute('aria-expanded') : null,
      menuDisplay: menu ? window.getComputedStyle(menu).display : null,
      menuHeight: menu ? menu.getBoundingClientRect().height : null,
      bodyOverflow: window.getComputedStyle(document.body).overflow,
    };
  }

  function forceUnlockScroll() {
    document.body.classList.remove('ha-frcp-nav-modal', 'ha-frcp-nav-open');
    document.documentElement.classList.remove('ha-frcp-nav-modal', 'ha-frcp-nav-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('touch-action');
    document.documentElement.style.removeProperty('overflow');

    var wrapper = document.querySelector('.body-wrapper');
    if (wrapper) wrapper.style.removeProperty('overflow');
  }

  function syncNavOpenState() {
    if (syncing || cleaning) return;
    syncing = true;

    var nav = getNav();
    var isOpen = !!(nav && mql.matches && nav.classList.contains('frcp-nav--open'));
    document.body.classList.toggle('ha-frcp-nav-modal', isOpen);

    log('syncNavOpenState', getNavSnapshot());
    syncing = false;
  }

  function hardCleanupNavState(source) {
    if (cleaning) return;
    cleaning = true;

    log('hardCleanupNavState', source || 'unknown', getNavSnapshot());

    var nav = getNav();
    var main = document.querySelector('.frcp-app .frcp-main');

    if (nav) nav.classList.remove('frcp-nav--open');
    if (main) main.classList.remove('frcp-main--menu-fixed');

    var toggle = getNavToggle(nav);
    if (toggle) toggle.setAttribute('aria-expanded', 'false');

    forceUnlockScroll();
    cleaning = false;
    syncNavOpenState();
  }

  function clickNavCloseButton() {
    var nav = getNav();
    if (!nav) return false;

    var closeBtn = nav.querySelector('.frcp-nav__dropdown-menu-close');
    if (!closeBtn) return false;

    closeBtn.click();
    return true;
  }

  function closeNavMenu(source) {
    log('closeNavMenu', source || 'unknown');
    clickNavCloseButton();
    window.setTimeout(function () {
      hardCleanupNavState('closeNavMenu');
    }, 0);
    window.setTimeout(function () {
      hardCleanupNavState('closeNavMenu-delayed');
    }, 150);
  }

  function isTopNavToggle(event, nav) {
    if (event.target.closest('.frcp-nav__menu')) return false;

    var toggle = getNavToggle(nav);
    return !!(toggle && toggle.contains(event.target));
  }

  function isBackdropClick(event) {
    if (!mql.matches) return false;

    var nav = getNav();
    if (!nav || !nav.classList.contains('frcp-nav--open') || !nav.contains(event.target)) return false;

    return (
      !event.target.closest('.frcp-nav__menu') &&
      !event.target.closest('.frcp-nav__title') &&
      !event.target.closest('.frcp-nav__dropdown-menu-close') &&
      !isTopNavToggle(event, nav)
    );
  }

  function applyNavMode() {
    if (applying) return;
    applying = true;

    document.querySelectorAll('.frcp-app .frcp-nav').forEach(function (nav) {
      if (mql.matches) {
        if (nav.classList.contains('frcp-nav--slider-menu')) {
          nav.dataset.haNavMode = 'slider';
          nav.classList.remove('frcp-nav--slider-menu');
          nav.classList.add('frcp-nav--dropdown-menu');
        }
      } else if (nav.dataset.haNavMode === 'slider') {
        nav.classList.remove('frcp-nav--dropdown-menu');
        nav.classList.add('frcp-nav--slider-menu');
        delete nav.dataset.haNavMode;
      }
    });

    log('applyNavMode', getNavSnapshot());
    syncNavOpenState();
    applying = false;
  }

  function handleNavClick(event) {
    var nav = event.target.closest('.frcp-app .frcp-nav.frcp-nav--dropdown-menu');
    if (!nav || !mql.matches) return;

    if (event.target.closest('.frcp-nav__dropdown-menu-close')) {
      log('click:close-button', getNavSnapshot());
      window.setTimeout(function () {
        hardCleanupNavState('close-button');
      }, 0);
      return;
    }

    if (event.target.closest('.frcp-nav__menu .frcp-nav-button')) {
      log('click:menu-item', event.target.closest('.frcp-nav__menu .frcp-nav-button').textContent.trim());
      return;
    }

    if (isTopNavToggle(event, nav)) {
      log('click:toggle', getNavSnapshot());
      syncNavOpenState();
      window.setTimeout(syncNavOpenState, 0);
      window.setTimeout(syncNavOpenState, 120);
    }
  }

  function init() {
    applyNavMode();
    mql.addEventListener('change', applyNavMode);

    document.addEventListener(
      'click',
      function (event) {
        if (!isBackdropClick(event)) return;

        log('click:backdrop', getNavSnapshot());
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        closeNavMenu('backdrop');
      },
      true
    );

    document.addEventListener('click', handleNavClick);

    var app = document.querySelector('.frcp-app');
    if (!app) {
      log('init: no .frcp-app found');
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        var target = mutation.target;
        return (
          target.classList &&
          (target.classList.contains('frcp-nav') || target.classList.contains('frcp-main'))
        );
      });

      if (relevant) {
        log('mutation', mutations.map(function (m) {
          return {
            type: m.type,
            attr: m.attributeName,
            target: m.target.className,
          };
        }));
        syncNavOpenState();
      }
    });

    observer.observe(app, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-expanded'],
    });

    window.addEventListener('resize', syncNavOpenState);
    window.addEventListener('hashchange', function () {
      hardCleanupNavState('hashchange');
    });
    window.addEventListener('pageshow', syncNavOpenState);

    window.haFrcpNavDebug = {
      snapshot: getNavSnapshot,
      sync: syncNavOpenState,
      cleanup: hardCleanupNavState,
      close: closeNavMenu,
      enable: function () {
        window.localStorage.setItem('ha-frcp-nav-debug', '1');
        DEBUG = true;
        console.log('[ha-frcp-nav] Debug activé. Rechargez la page.');
      },
      disable: function () {
        window.localStorage.removeItem('ha-frcp-nav-debug');
        DEBUG = false;
        console.log('[ha-frcp-nav] Debug désactivé.');
      },
    };

    log('init', getNavSnapshot());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
